export const volumes = [
  {
    numeral: "I",
    title: "The Clinical Assessment Roadmap",
    tagline: "Organize the Information Relevant to Patient Assessment.",
    intro: [
      "A structured approach to patient assessment begins with knowing which categories of information need to be reviewed and documented.",
      "This volume introduces educational frameworks for organizing patient history, assessment considerations, treatment-related information, and factors that may require additional evaluation.",
    ],
    explore: [
      "Patient history review frameworks",
      "Preliminary assessment worksheets",
      "Contraindication and precaution review considerations",
      "Patient-specific assessment documentation",
      "Treatment preparation worksheets",
      "Questions to consider when additional evaluation may be necessary",
    ],
    note: "The goal is to help you organize relevant information before making decisions within your professional scope.",
  },
  {
    numeral: "II",
    title: "Facial Anatomy and Clinical Reference Atlas",
    tagline: "Build a More Organized Foundation for Studying Facial Anatomy.",
    intro: [
      "Facial anatomy provides essential context for understanding aesthetic procedures and their associated risks.",
      "This volume organizes anatomical learning materials into a practical educational reference for qualified professionals.",
    ],
    explore: [
      "Major facial anatomical structures",
      "Facial vascular anatomy references",
      "Anatomical relationships relevant to injectable procedures",
      "Anatomical variation and individual differences",
      "Educational diagrams and visual study references",
      "Anatomical considerations associated with facial aesthetic treatments",
    ],
    note: "The material supports anatomical education. It does not establish universally safe injection locations, depths, or techniques.",
  },
  {
    numeral: "III",
    title: "The Clinical Complications Assessment Framework",
    tagline: "Study Potential Complications Through a Structured Educational Approach.",
    intro: [
      "Different post-treatment presentations may have different clinical significance.",
      "This volume organizes educational information about potential complications and provides a framework for reviewing presentations, documenting findings, and recognizing situations that require further assessment.",
    ],
    explore: [
      "Common post-treatment reactions",
      "Swelling, nodules, and inflammatory presentations",
      "Possible signs of infection",
      "Educational approaches to comparing clinical presentations",
      "Documentation of symptom onset and progression",
      "Warning signs that may require urgent evaluation",
      "Referral and escalation considerations",
    ],
    note: "You’ll also find comparative educational references to help you organize the information relevant to different clinical presentations.",
  },
  {
    numeral: "IV",
    title: "Vascular Warning Signs and Emergency Preparedness",
    tagline: "Understand the Importance of Recognizing Concerning Clinical Presentations.",
    intro: [
      "Potential vascular complications associated with injectable treatments require particular attention.",
      "This volume focuses on the educational aspects of warning-sign recognition, clinical observation, documentation, and emergency preparedness.",
    ],
    explore: [
      "Concerning changes in skin appearance",
      "The clinical significance of unusual or escalating pain",
      "Symptoms that may indicate ocular involvement",
      "Documentation of symptom onset and progression",
      "Considerations for urgent specialist assessment",
      "Emergency preparedness and referral pathways",
      "Educational case scenarios involving potential vascular complications",
    ],
    note: "The purpose is to support professional study and awareness. This volume does not replace hands-on training, current emergency protocols, or qualified clinical assessment and management.",
  },
  {
    numeral: "V",
    title: "Injectable Treatment Complications Reference",
    tagline: "Organize Your Study of Adverse Effects Associated With Injectable Procedures.",
    intro: [
      "Different injectable treatments can be associated with different adverse effects.",
      "This volume brings together educational references about complications associated with hyaluronic acid fillers and botulinum toxin treatments.",
    ],
    explore: [
      "Filler-associated swelling and nodules",
      "Potential inflammatory and infectious complications",
      "Unwanted aesthetic outcomes",
      "Eyelid ptosis and asymmetry following botulinum toxin treatment",
      "Other adverse effects requiring clinical evaluation",
      "Comparative educational tables",
      "Follow-up documentation and referral considerations",
    ],
    note: "The materials are intended to support continuing education and structured review, not to prescribe individualized treatment or management.",
  },
  {
    numeral: "VI",
    title: "Clinical Documentation and Follow-Up Roadmap",
    tagline: "Bring Greater Structure to Your Documentation Resources.",
    intro: [
      "A well-organized documentation system can support consistent recordkeeping and make it easier to locate relevant information.",
      "This volume focuses on the organization of patient records, treatment documentation, follow-up materials, and adverse-event records.",
    ],
    explore: [
      "Patient history and assessment templates",
      "Treatment documentation worksheets",
      "Photographic documentation checklists",
      "Follow-up record templates",
      "Adverse-event documentation forms",
      "Patient communication records",
      "Referral and escalation documentation",
      "Clinical review checklists",
    ],
    note: "These materials are designed to be adapted to your professional setting, scope of practice, and applicable local requirements.",
  },
];
